export const GOOGLE_FORM_LINK = 'http://bit.ly/techInCzech';
